import { Button, InputNumber, Modal, Table } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import React from 'react';
import { CreatedBagInfo } from '../graphql/types/ConsolidationTypes';
import { useTranslation } from 'react-i18next';
interface NewBagModalProps {
  visible: boolean;
  newBags: CreatedBagInfo[];
  onPrint: () => void;
  onOk: () => void;
}

const NewBagModal: React.FC<NewBagModalProps> = ({ visible, newBags, onPrint, onOk }) => {
  const { t } = useTranslation();
  const columns: ColumnsType<CreatedBagInfo> = [
    {
      title: t('wms.baggingTask.filters.bagNo'),
      dataIndex: 'bagNumber',
      key: 'bagNumber'
    },
    {
      title: t('wms.baggingTask.filters.bagCode'),
      dataIndex: 'bagCode',
      key: 'bagCode'
    },
    {
      title: t('wms.baggingTask.filters.bagCount'),
      dataIndex: 'actualParcelCount',
      key: 'actualParcelCount',
      render: (count: number) => (
        <InputNumber value={count} disabled style={{ width: '100%' }} />
      )
    }
  ];

  return (
    <Modal
      title={t('wms.baggingTask.buttons.newBagCreated')}
      visible={visible}
      footer={
        <div style={{ textAlign: 'right' }}>
          <Button onClick={onPrint}>Print</Button>
          <Button type="primary" onClick={onOk} style={{ marginLeft: 8 }}>
            {t('components.button.ok')}
          </Button>
        </div>
      }
      onCancel={onOk}
      width={600}
      destroyOnClose
    >
      <Table
        dataSource={newBags}
        columns={columns}
        rowKey="bagId"
        pagination={false}
        size="small"
       className="mb-4"/>
    </Modal>
  );
};

export default NewBagModal;